export default "__VITE_ASSET__9ce09d85__"